export const TAX_APPS = [
  { value: 'coinledger', label: 'Coinledger' },
  { value: 'cointracker', label: 'Cointracker' },
  { value: 'cointracking', label: 'Cointracking' },
  { value: 'cryptotaxcalculator', label: 'Crypto tax calculator' },
  { value: 'koinly', label: 'Koinly' },
  { value: 'zenledger', label: 'Zenledger' }
];
